import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import useMainDialogStore, { DIALOG_SIZE, DIALOG_IMAGE_SIZE } from '~/stores/useMainDialogStore';
export default /*#__PURE__*/_defineComponent({
  __name: 'MainDialog',
  setup: function setup(__props) {
    var DIALOG_WIDTH = _defineProperty(_defineProperty({}, DIALOG_SIZE.XS, 304), DIALOG_SIZE.MD, 550);
    var IMAGE_HEIGHT = _defineProperty(_defineProperty({}, DIALOG_IMAGE_SIZE.XS, 150), DIALOG_IMAGE_SIZE.MD, 175);
    var isCloseLoading = ref(false);
    var isConfirmLoading = ref(false);
    var $dialog = useMainDialogStore();
    var _storeToRefs = storeToRefs($dialog),
      isActive = _storeToRefs.isActive,
      isDanger = _storeToRefs.isDanger,
      persistent = _storeToRefs.persistent,
      confirmHandler = _storeToRefs.confirmHandler,
      closeHandler = _storeToRefs.closeHandler,
      title = _storeToRefs.title,
      text = _storeToRefs.text,
      image = _storeToRefs.image,
      imageSize = _storeToRefs.imageSize,
      closeText = _storeToRefs.closeText,
      confirmText = _storeToRefs.confirmText,
      afterText = _storeToRefs.afterText,
      imageCaption = _storeToRefs.imageCaption,
      size = _storeToRefs.size;
    onBeforeMount(function () {
      window.addEventListener('popstate', $dialog.close);
    });
    onBeforeUnmount(function () {
      window.removeEventListener('popstate', $dialog.close);
    });
    function closeHandlerOutside() {
      if (persistent.value) {
        return;
      }
      handleClose();
    }
    function handleClose() {
      return _handleClose.apply(this, arguments);
    }
    function _handleClose() {
      _handleClose = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var handler;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              handler = closeHandler.value;
              if (!handler) {
                _context.next = 10;
                break;
              }
              _context.prev = 2;
              isCloseLoading.value = true;
              _context.next = 6;
              return handler();
            case 6:
              _context.prev = 6;
              isCloseLoading.value = false;
              $dialog.close();
              return _context.finish(6);
            case 10:
              $dialog.close();
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2,, 6, 10]]);
      }));
      return _handleClose.apply(this, arguments);
    }
    function handleConfirm() {
      return _handleConfirm.apply(this, arguments);
    }
    function _handleConfirm() {
      _handleConfirm = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var handler;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              handler = confirmHandler.value;
              if (!handler) {
                _context2.next = 10;
                break;
              }
              _context2.prev = 2;
              isConfirmLoading.value = true;
              _context2.next = 6;
              return handler();
            case 6:
              _context2.prev = 6;
              isConfirmLoading.value = false;
              $dialog.close();
              return _context2.finish(6);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2,, 6, 10]]);
      }));
      return _handleConfirm.apply(this, arguments);
    }
    return {
      __sfc: true,
      DIALOG_WIDTH: DIALOG_WIDTH,
      IMAGE_HEIGHT: IMAGE_HEIGHT,
      isCloseLoading: isCloseLoading,
      isConfirmLoading: isConfirmLoading,
      $dialog: $dialog,
      isActive: isActive,
      isDanger: isDanger,
      persistent: persistent,
      confirmHandler: confirmHandler,
      closeHandler: closeHandler,
      title: title,
      text: text,
      image: image,
      imageSize: imageSize,
      closeText: closeText,
      confirmText: confirmText,
      afterText: afterText,
      imageCaption: imageCaption,
      size: size,
      closeHandlerOutside: closeHandlerOutside,
      handleClose: handleClose,
      handleConfirm: handleConfirm
    };
  }
});